import {instance, onErrorFunction, onSuccessFunction} from "../../../config/axios-cnf";

export const buildCommandListUrl = (subjectId) =>
    "/api/v2/enigoo/" + subjectId + "/turnstile-command";

/**
 * Z hodnot filtru poskládá query parametry. Prázdné hodnoty vynechá,
 * pole posílá jako opakovaný klíč (type=a&type=b) — Spring jinak filtr nenaparsuje.
 * Datum z formuláře má tvar 2026-08-17T00:00, backend čeká i sekundy.
 */
export const buildCommandListParams = (filterValues, page, size) => {
    const params = new URLSearchParams();
    const withSeconds = (d) => (d ? (d.length === 16 ? d + ":00" : d) : null);

    const dateFrom = withSeconds(filterValues?.dateFrom);
    const dateTo = withSeconds(filterValues?.dateTo);
    if (dateFrom) params.append("dateFrom", dateFrom);
    if (dateTo) params.append("dateTo", dateTo);
    if (filterValues?.turnstileId) params.append("turnstileId", filterValues.turnstileId);
    (filterValues?.type || []).forEach((t) => params.append("type", t));
    (filterValues?.state || []).forEach((s) => params.append("state", s));
    params.append("page", page ?? 0);
    if (size) params.append("size", size);
    return params;
};

export const apiGetCommandList = (subjectId, filterValues, page, size, callback, error) => {
    const params = buildCommandListParams(filterValues, page, size);
    instance.get(buildCommandListUrl(subjectId) + "?" + params.toString())
        .then((r) => {
            // Proxy vrací HTTP 200 i pro chybu backendu — chybu nese tělo.
            if (r?.data && r.data.result === false) {
                error(typeof r.data.data === "string" ? r.data.data : null);
                return;
            }
            callback(onSuccessFunction(r.data));
        })
        .catch((e) => error(onErrorFunction(e)));
};
